<template>
  <div>
    <div :formInline="formInline" :formInlineCopy="formInlineCopy" :buttonList="buttonList">
      <el-form :inline="true" size="mini" :model="formInline" class="from-view" ref="formInline">
        <el-row>
          <el-col :span="20">
            <el-form-item>
              <el-input prefix-icon="el-icon-search" style="width: 330px;" v-model="formInline.keyword" :placeholder="showDoctor ? searchContent : $store.state.userPlatForm === 'platForm' ? '请输入团队名称/线下机构' : '请输入团队名称'" clearable> </el-input>
            </el-form-item>
            <el-form-item v-if="formInline.hasOwnProperty('doctorType')">
              <el-select v-model="formInline.doctorType" placeholder="选择类型" clearable >
                <el-option label="医生" :value="1"></el-option>
                <el-option label="护士" :value="2"></el-option>
                <!-- <el-option label="医技" :value="3" :key="subIndex"></el-option> -->
                <el-option v-if="userPlatForm != 'organization'" label="药师" :value="4"></el-option>
                <el-option label="医辅" :value="6"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item v-if="showDoctor" >
              <el-select v-model="formInline.disabled" placeholder="选择状态" clearable >
                <el-option :label="sub.name" :value="sub.value" v-for="(sub, subIndex) in disableTypeList" :key="subIndex"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-row type="flex" justify="end">
                <el-button size="mini" @click="resetHandel">重置</el-button>
                <el-button type="primary" size="mini" @click="queryHandel" style="margin-left: 20px">搜索</el-button>
              </el-row>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-row type="flex" justify="end" v-if="showDoctor">
              <el-form-item>
                <el-button type="primary" size="mini" @click="newAddDocPeopel">新增医护</el-button>
              </el-form-item>
            </el-row>
            <el-row type="flex" justify="end" v-if="showDoctorTeam">
              <el-form-item >
                <el-button type="primary" size="mini" @click="newAddDocPeopel">新增团队</el-button>
              </el-form-item>
            </el-row>
          </el-col>
          <div style="clear: both;"></div>
        </el-row>
      </el-form>
    </div>
	<div class="placeholder-div">
	</div>
  </div>
</template>

<script>
import local from "@/utils/local.js";
import { hospital, openeDpartment } from '@/api/doctorTeam.js'
export default {
  name: 'Basequery',
  props: {
    formInline: {
      type: Object,
      default: () => {},
    },

    formInlineCopy: {
      type: Object,
      default: () => {},
    },
    buttonList: {
      type: Array,
      default: () => [],
    },
    apiType:{
      type: Boolean,
      default: false,
    },
	showDoctor:{
      type: Boolean,
      default: false,
    },
	showDoctorTeam:{
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      setKesDept: {
        value: 'id',
        label: 'name',
        children: 'children',
        disabled: 'value'
      }, //设置联级选择器绑定的值
      hospitalList: [], //所属医院
      departmentList: [], //归属科室
      dataArray: [[], [], []],
      searchContent: local.get('userPlatForm') == 'platForm' ? '请输入姓名/线下机构' : '请输入姓名/线下科室',
      userPlatForm:local.get('userPlatForm'),//平台：platForm 机构：organization local.get('userPlatForm') 
	  disableTypeList:[
	    {
	      value: false,
	      name: '启用',
	    },
	    {
	      value: true,
	      name: '禁用',
	    },
		]
    }
  },
  created() {
    this.getHospital()
    this.addselectOnChange()//查询条件可以与医院做关联 也可以不做关联 
  },
  methods: {
    /**
     * @description:通知是否全选，修改状态筛选
     * @event:
     * @param {*}
     * @return {*}
     */
    asd(index, event) {
      Object.keys(this.formInlineCopy).forEach((item, index) => {
        this.dataArray[index] = this.formInlineCopy[item]
      })
      let data = JSON.parse(JSON.stringify(this.dataArray))
      data = data.flat().join('')
      let datas = ''
      this.buttonList.forEach((item) => {
        item.list.forEach((sub) => {
          datas = datas + sub.value
        })
      })
      if (data.length == datas.length) {
        this.$emit('equal', true)
      } else {
        this.$emit('equal', false)
      }
    },

    /**
     * @description: 重置
     * @event:
     * @param {*}
     * @return {*}
     */
    resetHandel() {
      this.$emit('resetHandel')
    },
    /**
     * @description: 查询条件
     * @event:
     * @param {*}
     * @return {*}
     */

    queryHandel() {
      // return
      this.$emit('formData', {
        ...this.formInline,
        ...this.formInlineCopy,
		disabledList:[this.formInline.disabled]
      })
    },
	newAddDocPeopel() {
      // return
      this.$emit('newAddDocPeopel')
    },
    /**
     * @description: 获取医院列表
     * @event:
     * @param {*}
     * @return {*}
     */

    getHospital() {
      hospital({
        disabled:false
      }).then((res) => {
        if (res.code == 0) {
          this.departmentList = res.data
        }
      })
    },

    /**
     * @description: 获取相应医院下的科室
     * @event:
     * @param {*}
     * @return {*}
     */
    addselectOnChange(event) {
      this.hospitalList = []
      this.formInline.departmentId = ''
      openeDpartment({
        hospitalId: event,
      }).then((res) => {
        if (res.code == 0) {
          this.hospitalList = res.data
        }
      })
    },
  },
}
</script>

<style lang="less" scoped>
.placeholder-div{
	height: 15px;
	width: calc(100%+40px);
	margin-left: -20px;
	margin-right: -20px;
	background: #F8F8F8;
}
.from-view {
  & /deep/ .el-form-item__label {
    font-size: 12px !important;
  }
}
.el-form--inline .el-form-item {
  margin-right: 20px;
}
</style>
